module.exports = __webpack_public_path__ + "img/切換星座current.9a6c127e.svg";